import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  sidebarButtonInfo: {
    id: 'course-authoring.unit-page.sidebar.info.sidebar-button-info',
    defaultMessage: 'Info',
    description: 'Label of the button for the Info sidebar',
  },
  sidebarButtonAlign: {
    id: 'course-authoring.unit-page.sidebar.info.sidebar-button-align',
    defaultMessage: 'Align',
    description: 'Label of the button for the Align sidebar',
  },
  sidebarButtonAdd: {
    id: 'course-authoring.unit-page.sidebar.add.sidebar-button-add',
    defaultMessage: 'Add',
    description: 'Label of the button for the Add sidebar',
  },
  sidebarAddNewTab: {
    id: 'course-authoring.unit-page.sidebar.add.tab.add-new',
    defaultMessage: 'Add New',
    description: 'Label of tab in the sidebar for add new content.',
  },
  sidebarAddExistingTab: {
    id: 'course-authoring.unit-page.sidebar.add.tab.add-existing',
    defaultMessage: 'Add Existing',
    description: 'Label of tab in the sidebar for add existing content.',
  },
  sidebarAddTextButton: {
    id: 'course-authoring.unit-page.sidebar.add.new.text',
    defaultMessage: 'Text',
    description: 'Label for the button to create a new Text block',
  },
  sidebarAddProblemButton: {
    id: 'course-authoring.unit-page.sidebar.add.new.problem',
    defaultMessage: 'Problem',
    description: 'Label for the button to create a new Problem block',
  },
  sidebarAddVideoButton: {
    id: 'course-authoring.unit-page.sidebar.add.new.video',
    defaultMessage: 'Video',
    description: 'Label for the button to create a new Video block',
  },
  sidebarAddOpenResponseButton: {
    id: 'course-authoring.unit-page.sidebar.add.new.open-response',
    defaultMessage: 'Open Response',
    description: 'Label for the button to create a new Open Response block',
  },
  sidebarAddProblemBankButton: {
    id: 'course-authoring.unit-page.sidebar.add.new.problem-bank',
    defaultMessage: 'Problem Bank',
    description: 'Label for the button to create a new Problem Bank block',
  },
  sidebarAddDragDropButton: {
    id: 'course-authoring.unit-page.sidebar.add.new.drag-and-drop',
    defaultMessage: 'Drag Drop',
    description: 'Label for the button to create a new Drag and Drop block',
  },
  sidebarAddAdvancedButton: {
    id: 'course-authoring.unit-page.sidebar.add.new.advanced',
    defaultMessage: 'Advanced',
    description: 'Label for the button to open the Advanced blocks list',
  },
  videoPickerModalTitle: {
    id: 'course-authoring.course-unit.sidebar.modal.video-title.text',
    defaultMessage: 'Select video',
    description: 'Video picker modal title.',
  },
  sidebarAddBackButton: {
    id: 'course-authoring.course-unit.sidebar.add.back.button',
    defaultMessage: 'Back',
    description: 'Label for the button to go back from the add advanced block page',
  },
  sidebarAddAdvancedBlocksTitle: {
    id: 'course-authoring.course-unit.sidebar.add.back.button',
    defaultMessage: 'Advanced Blocks',
    description: 'Title for the add advanced blocks page in the unit sidebar',
  },
  sidebarDisabledAddTooltip: {
    id: 'course-authoring.course-unit.sidebar.add.disabled.tooltip',
    defaultMessage: 'Cannot add content to components',
    description: 'Tooltip for the Add sidebar when is disabled.',
  },
});

export default messages;
